module.exports = __webpack_public_path__ + "static/media/TRAVERSE GUIDE MOULDING - SQUARE ( 466 - 00256 ) FOR SDS 900-1200 MACHINES..199983a6.jpg";